import styled from '@emotion/styled';
import {
  blueActiveColor,
  blueDisabledColor,
  blueEnabledColor,
  blueHoverColor,
  lightGrey,
  darkGrey,
  white,
  superLightGrey,
  appTextColor,
  mediumDarkGrey,
  lightestGrey,
  linkColor,
  workspaceLinkColor
} from './colors';
import { breakpoints } from './constants'

export const LaunchpadButton = styled.div((props) => {
  let style = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '20px',
    backgroundColor: blueEnabledColor,
    color: white,
    height: '40px',
    width: '100%',
    letterSpacing: '1px',
    fontSize: '12px',
    lineHeight: '15px',
    fontWeight: '400',
    cursor: 'pointer',
    outline: 'none',
    ':hover': {
      backgroundColor: blueHoverColor
    },
    ':hover:active': {
      backgroundColor: blueActiveColor
    },
    ':focus': {
      border: '1px solid ' + (props.disabled ? lightGrey : blueActiveColor)
    }
  };
  if (props.disabled) {
    style.backgroundColor = blueDisabledColor;
    style.pointerEvents = 'none';
  }
  return style;
});


export const Link = styled.a((props) => {
let style = {
  cursor: 'pointer',
  textAlign: 'center',
  color: linkColor,
  ':hover': {
    textDecoration: 'underline'
  },
  ':hover:active': {
    textDecoration: 'underline'
  },
  display: 'inline-block',
  padding: '0 10.0px 0 10.0px'
};
if (props.longLanguage) {
  style.display = 'flex';
  style.alignItems = 'center';
  style.justifyContent = 'center';
}
if (props.disabled) {
  style.pointerEvents = 'none';
}
return style;
});


export const LaunchpadButtonNew = styled.button((props) => {
  let style = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '40px',
    backgroundColor: linkColor,
    color: white,
    width: '100%',
    letterSpacing: '1px',
    fontSize: '18px',
    fontWeight: '400',
    cursor: 'pointer',
    outline: 'none',
    padding: '14.5px 0',
    border: 'none',
    appearance: 'none',
    ':hover': {
      backgroundColor: linkColor
    },
    ':hover:active': {
      backgroundColor: blueActiveColor
    },
    ':focus': {
      border: '1px solid ' + (props.disabled ? lightGrey : blueActiveColor)
    }
  };
  if (props.disabled) {
    style.backgroundColor = blueDisabledColor;
    style.pointerEvents = 'none';
  }
  return style;
});




export const WorkspaceLink = styled.div((props) => {
  let style = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '20px',
    backgroundColor: white,
    color: workspaceLinkColor,
    padding: '7.5px',
    width: '100%',
    fontSize: '14px',
    fontWeight: '400',
    cursor: 'pointer',
    border: `1px solid ${workspaceLinkColor}`,
    textAlign: 'center',
    'svg': {
      margin: '2px 0 0 5px',
      display: props.workspaceButtonAdjustedForTextLength ? 'none' : 'inline',
    },
    'br': {
      display: props.workspaceButtonAdjustedForTextLength ? 'block' : 'none',
    },
    [breakpoints.SCREEN_S]: {
      'br': {
        display: 'block'
      },
      'svg': {
        position: 'relative',
        right: '-10px',
      }
    }

    // ':hover': {
    //   backgroundColor: linkColor
    // },
    // ':hover:active': {
    //   backgroundColor: blueActiveColor
    // },
    // ':focus': {
    //   border: '1px solid ' + (props.disabled ? lightGrey : blueActiveColor)
    // }
  };

  // In every screen, everything below the Header text has a 20px margin gap.
  // except the consumer login....it has 12px. So we use this prop to offset it (ie, by -8px)
  if (props.topMargin) {
    style.marginTop = this.props.topMargin
  }
  if (props.disabled) {
    style.backgroundColor = white;
    style.pointerEvents = 'none';
  }
  return style;
});

export const WhiteLaunchpadButton = styled(LaunchpadButton)((props) => {
  let style = {
    backgroundColor: white,
    border: '1px solid ' + lightGrey,
    color: appTextColor,
    ':hover': {
      backgroundColor: white,
      borderColor: mediumDarkGrey
    },
    ':hover:active': {
      backgroundColor: superLightGrey,
      borderColor: darkGrey
    },
    ':focus': {
      border: '1px solid ' + (props.disabled ? lightestGrey : mediumDarkGrey)
    }
  };
  return style;
});



// WEBPACK FOOTER //
// ./src/styles/LaunchpadButton.js